module.exports = __webpack_public_path__ + "static/media/161008-DSC05301-42_Small.4a68edf7.jpg";